import { useEffect, useRef } from 'react';
import debounce from 'utils/debounce';

const useWindowResizeEffect = callback => {
  const debounceRef = useRef();

  useEffect(() => {
    if (typeof window !== 'object') {
      return false;
    }

    const handleResize = () => {
      if (debounceRef.current) {
        debounceRef.current.cancel();
      }
      debounceRef.current = debounce(callback, 100);
      debounceRef.current();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      if (debounceRef.current) {
        debounceRef.current.cancel();
      }
      window.removeEventListener('resize', handleResize);
    };
  }, [callback]);
};

export default useWindowResizeEffect;
